import { defineStore } from 'pinia'

export type { User } from '~/types/user'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null,
    isLoading: false,
    isInitialized: false,
    error: null as string | null,
  }),
  actions: {
    setUser(user: User | null) {
      this.user = user
      this.isInitialized = true
    },
    clearUser() {
      this.user = null
      this.isInitialized = false
    },
  },
})
